import { render, staticRenderFns } from "./DiversificationMeasure.vue?vue&type=template&id=e24a6c9c&"
import script from "./DiversificationMeasure.vue?vue&type=script&lang=js&"
export * from "./DiversificationMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports